import { NgModule } from '@angular/core';
import { MatButtonModule, MatDialogModule, MatIconModule, MatTooltipModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { ViewQrCodeModalComponent } from './view-qr-code-modal.component';
import { ViewQrCodeModalService } from './view-qr-code-modal.service';

@NgModule({
  declarations: [ViewQrCodeModalComponent],
  imports: [
    MatDialogModule,
    MatIconModule,
    TranslateModule,
    MatTooltipModule,
    MatButtonModule
  ],
  providers: [ViewQrCodeModalService],
  exports: [],
  entryComponents: [ViewQrCodeModalComponent]
})
export class ViewQrCodeModalModule {}
